<div class="modal-header">
  <h5 class="modal-title">Filters : {{filterName | translate}}</h5>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12 mb-2">
      <label>
        <input
          type="radio"
          name="sortOption"
          (change)="changeSortOption('alphabetical')"
          checked
        />
        Sort A-Z
      </label>
      <label class="ms-2">
        <input
          type="radio"
          name="sortOption"
          (change)="changeSortOption('count')"
        />
        Sort by Count
      </label>
    </div>
    <div class="col-12">
      <ol class="list-group list-group-numbered">
        @for (item of filters2; track $index) {
        <li (click)="onFilterClick(item)" style=" cursor: pointer;"
          class="list-group-item d-flex justify-content-between align-items-start list-group-item list-group-item-action"
        >
          <div class="ms-2 me-auto ">
            <div class="fw-bold">{{ item.name }}</div>
          </div>
          <span class="badge bg-primary rounded-pill">{{ item.count }}</span>
        </li>
        }
      </ol>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="activeModal.dismiss('Cancel click')"
    >
      Close
    </button>
  </div>
</div>
